import type { AxiosResponse } from 'axios'

export class LeafletMutationStatusError extends Error {
  readonly response: AxiosResponse

  constructor(response: AxiosResponse) {
    super(`Unexpected leaflet mutation status: ${response.status}`)
    this.name = 'LeafletMutationStatusError'
    this.response = response
  }
}

export function expectLeafletMutationStatus<T>(response: AxiosResponse<T>, expected: number): AxiosResponse<T> {
  if (response.status !== expected) throw new LeafletMutationStatusError(response)
  return response
}
